import React from 'react';
import { cn } from '../../lib/utils';

export const TableRoot: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...props }) => (
  <div className={cn('overflow-x-auto', className)} {...props}>{children}</div>
);

export const Table: React.FC<React.TableHTMLAttributes<HTMLTableElement>> = ({ className, children, ...props }) => (
  <table className={cn('table', className)} {...props}>{children}</table>
);

export const THead: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = ({ className, children, ...props }) => (
  <thead className={cn('table-header', className)} {...props}>{children}</thead>
);

export const TR: React.FC<React.HTMLAttributes<HTMLTableRowElement>> = ({ className, children, ...props }) => (
  <tr className={cn('table-row', className)} {...props}>{children}</tr>
);

export const TH: React.FC<React.ThHTMLAttributes<HTMLTableCellElement>> = ({ className, children, ...props }) => (
  <th className={cn('table-header-cell', className)} {...props}>{children}</th>
);

export const TBody: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = ({ className, children, ...props }) => (
  <tbody className={cn('table-body', className)} {...props}>{children}</tbody>
);

export const TD: React.FC<React.TdHTMLAttributes<HTMLTableCellElement>> = ({ className, children, ...props }) => (
  <td className={cn('table-cell', className)} {...props}>{children}</td>
);
